import React, { useState } from 'react';
import Form from 'deltoid/core/Form';
import { Caption } from 'deltoid/core/Blocks/Typography';
import clsx from 'clsx';

const WhyTooltip = ({
  heading,
  body,
  isMobile,
  testId,
}) => {
  const [open, setOpen] = useState(false);
  const className = clsx(
    'tooltip-container',
    {
      'mobile': isMobile,
      'hide': !open,
    },
  );
  const btnClassName = clsx(
    'why-btn',
        {
          'd-block': isMobile ,
          'm-auto': isMobile,
  });
  return (
    <Form.Button
      onClick={() => {}}
      type='button'
      variant='underlined'
      className={btnClassName}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      Why we need this?
      <div className={className} data-testid={testId || 'why-tool-tip'}>
        {heading && <Caption variant='bold' className='mb-2 text-dark'>{heading}</Caption>}
        {body && <Caption className='text-dark'>{body}</Caption>}
      </div>
    </Form.Button>
  );
};

export default WhyTooltip;
